import { gql } from '@apollo/client';
import CardContainer from '../CardContainer/CardContainer.pim';
import CardSection from '../ContentSystem/components/CardSection/CardSection';
import ContentBlock from '../ContentBlock/ContentBlock.pim';
import HeaderBlock from '../HeaderBlock.pim/HeaderBlock';
import HeaderSection from '../ContentSystem/components/HeaderSection/HeaderSection';
import ImageSection from '../ContentSystem/components/ImageSection/ImageSection';
import TextBlock from '../ContentfulTextBlock/ContentfulTextBlock.pim';
import TextSection from '../ContentSystem/components/TextSection/TextSection';

export const ResponsiveContainerFragment = gql`
  fragment ResponsiveContainerFragment on ResponsiveContainer {
    ... on ResponsiveContainer {
      __typename
      id
      title
      desktopOnly {
        __typename
        ...CardContainerFragment
        ...CardSectionFragment
        ...ContentBlockFragment
        ...HeaderBlockFragment
        ...HeaderSectionFragment
        ...ImageSectionFragment
        ...TextBlockFragment
        ...TextSectionFragment
      }
      mobileOnly {
        __typename
        ...CardContainerFragment
        ...CardSectionFragment
        ...ContentBlockFragment
        ...HeaderBlockFragment
        ...HeaderSectionFragment
        ...ImageSectionFragment
        ...TextBlockFragment
        ...TextSectionFragment
      }
    }
  }
  ${CardContainer.fragment}
  ${CardSection.fragment}
  ${ContentBlock.fragment}
  ${HeaderBlock.fragment}
  ${HeaderSection.fragment}
  ${ImageSection.fragment}
  ${TextBlock.fragment}
  ${TextSection.fragment}
`;

export default {};
